import React from "react";
import { Layout, Card, Image, Typography, Form, Input, Button, message } from "antd";
import { Navigate } from 'react-router-dom';

import logo from '../assets/slog1.png';
import { POST_API, POST_CATCH } from "../services/api";

class Confirm extends React.Component {

    state = { _navigate: false, _params: window.location.href.split('/'), }

    onSend = (values) => {

        this.setState({_loading: true})

        values.COD = this.state._params[4];

        POST_API('/credential/confirm_access.php', { token: 'X', master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success({ content: res.msg, key: 'screen' })
                this.setState({_navigate: true})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_loading: false}))

    }

    render = () => {

        if (this.state._navigate) return ( <Navigate to='/' />)

        return (
            <Layout.Content className="login-content">
                <Card className="login-card">
                    <center><Image src={logo} preview={false} className="login-card-image"/></center>
                    <Typography className="login-card-title">Confirmar Acesso</Typography>
                    <Form layout="vertical" onFinish={this.onSend}>
                        <Form.Item label="Senha" name="PASSWORD" className="login-form-item" rules={[{required: true, message: 'Campo Obrigatório'}]}>
                            <Input.Password />
                        </Form.Item>
                        <Form.Item className="login-form-item">
                            <Button htmlType="submit" type="primary" block className="btn-primary" shape="round" loading={this.state._loading}>Finalizar Processo</Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Layout.Content>
        )
    }

}

export default Confirm;